module.exports = __webpack_public_path__ + "img/trade-c.6d45f60c.svg";